import React from 'react';
import AppImage from '@/components/ui/AppImage';

interface CertificationBadgeProps {
  certification: {
    id: number;
    name: string;
    logo: string;
    alt: string;
    category: string;
  };
}

const CertificationBadge = ({ certification }: CertificationBadgeProps) => {
  return (
    <div className="glassmorphic rounded-xl p-6 hover:shadow-premium transition-all duration-500 hover:-translate-y-2 group shadow-silver-glow hover:shadow-orange-glow-hover card-3d-glow">
      <div className="relative w-24 h-24 mx-auto mb-4 rounded-lg overflow-hidden bg-background/50 flex items-center justify-center">
        <AppImage
          src={certification.logo}
          alt={certification.alt}
          className="w-20 h-20 object-contain group-hover:scale-110 transition-transform duration-300"
        />
      </div>
      <h4 className="text-sm font-semibold text-foreground text-center mb-1 group-hover:text-primary transition-colors duration-300">
        {certification.name}
      </h4>
      <p className="text-xs text-muted-foreground text-center">{certification.category}</p>
    </div>
  );
};

export default CertificationBadge;